import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Button, Col, Form, Row, Spinner } from 'react-bootstrap';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { useAuth } from 'context/AuthContext';
import axiosInstance from 'axiosInstance';
import { getDefaultWorkspaceRoute } from 'helpers/workspace';

const LoginForm = ({ hasLabel }) => {

  const { t } = useTranslation();
  
  const navigate = useNavigate();

  const { login } = useAuth(); 
  // State
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    remember: false
  });

  const [loading, setLoading] = useState(false);

  const [ searchParams ] = useSearchParams();

  // Handler
  const handleSubmit = e => {
    e.preventDefault();
    setLoading(true);

    axiosInstance.post('login/login', {
      email: formData.email,
      password: formData.password
    },
    {
      //headers: {"Access-Control-Allow-Origin": "*"}
    })
    .then(function (response) {
      console.log(response);
      const auth = response.data.auth || {};
      const authUser = auth.user || {};

      login({
        userId: authUser.id || 1,
        userName: authUser.username || authUser.email || formData.email,
        userEmail: authUser.email || formData.email,
        user: authUser,
        remember: formData.remember,
        integrations: response.data.integrations,
        providers: response.data.providers || {},
        permissions: auth.permissions || [],
        company: auth.company || null,
        companies: auth.companies || [],
        profile: auth.profile || null,
        membership: auth.membership || null,
        activeIntegration: auth.active_integration || response.data.active_integration || null,
        workspace: auth.workspace || null
      });
      toast.success(t('LOGIN.LOGGED_AS', { value: authUser.email || formData.email }), {
        theme: 'colored'
      });
      const next = searchParams.get('next');
      if(next != undefined && next != ''){
        navigate(next);
      } else {
        navigate(getDefaultWorkspaceRoute(auth.workspace?.mode));
      }
    })
    .catch(function (error) {
      console.log(error);
      toast.error(t('LOGIN.INVALID_LOGIN'), {
        theme: 'colored'
      });
      setLoading(false);
    });
  };

  const handleFieldChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <Form onSubmit={handleSubmit}>

      <Form.Group className="mb-3">
        {hasLabel && <Form.Label>{t('LOGIN.EMAIL')}</Form.Label>}
        <Form.Control
          placeholder={!hasLabel ? t('LOGIN.EMAIL') : ''}
          value={formData.email}
          name="email"
          onChange={handleFieldChange}
          type="email"
          disabled={loading}
        />
      </Form.Group>

      <Form.Group className="mb-3">
        {hasLabel && <Form.Label>{t('LOGIN.PASSWORD')}</Form.Label>}
        <Form.Control
          placeholder={!hasLabel ? t('LOGIN.PASSWORD') : ''}
          value={formData.password}
          name="password"
          onChange={handleFieldChange}
          type="password"
          disabled={loading}
        />
      </Form.Group>

      <Row className="justify-content-between align-items-center">
        <Col xs="auto">
          <Form.Check type="checkbox" id="rememberMe" className="mb-0">
            <Form.Check.Input
              type="checkbox"
              name="remember"
              checked={formData.remember}
              disabled={loading}
              onChange={e =>
                setFormData({
                  ...formData,
                  remember: e.target.checked
                })
              }
            />
            <Form.Check.Label className="mb-0 text-700">
              {t('LOGIN.REMEMBER_ME')}
            </Form.Check.Label>
          </Form.Check>
        </Col>

        <Col xs="auto">
          <Link
            className="fs--1 mb-0"
            to={`/login/forgot-password`}
          >
            {t('LOGIN.FORGOT_PASSWORD')}
          </Link>
        </Col>
      </Row>

      <Form.Group>
        <Button
          type="submit"
          color="primary"
          className="mt-3 w-100"
          disabled={!formData.email || !formData.password || loading}
        >
          {loading ? (
            <Spinner animation="border" size="sm" role="status" />
          ) : (
            t('LOGIN.LOGIN')
          )}
        </Button>
      </Form.Group>
    </Form>
  );
};

LoginForm.propTypes = {
  layout: PropTypes.string,
  hasLabel: PropTypes.bool
};

LoginForm.defaultProps = {
  layout: 'simple',
  hasLabel: false
};

export default LoginForm;
